module.exports = __webpack_public_path__ + "static/media/63.45b7684b.gif";